import { Survey } from 'survey-react-ui'
import 'survey-core/defaultV2.min.css'
import { StylesManager } from 'survey-core'
import 'survey-core/survey.i18n'
import './index.css'
import { cssClassesForSurvey } from './css-classes'
import { useTranslation } from 'react-i18next'
import { exitButtonClasses, extraActionButtonClasses } from './styles'
import { useEffect } from 'react'

StylesManager.applyTheme('defaultV2')

export const SRSurvey = ({
  survey,
  onChange,
  onComplete,
  completeText,
  onExit,
  extraAction,
  extraActionText,
  extraActionVisible,
  hideNavigation = false,
  autoValidate = false,
}) => {
  const { t } = useTranslation()

  useEffect(() => {
    survey.locale = 'es'
    survey.mode = 'edit'  // Forzar modo editable para evitar inputs disabled
    survey.clearInvisibleValues = 'onHiddenContainer' 
    survey.onValueChanging.add(onChange)
    survey.css = cssClassesForSurvey
    survey.onComplete.add((sender, options) => onComplete(sender, options))
    survey.completeText = completeText

    if (hideNavigation) {
      survey.showNavigationButtons = false
    }

    if (onExit) {
      survey.addNavigationItem({
        id: 'survey-on-exit-button',
        css: exitButtonClasses,
        title: t('common:exit'),
        visibleIndex: 49,
        action: () => onExit(),
      })
    }

    if (extraAction) {
      survey.addNavigationItem({
        id: 'survey-extra-action-button',
        css: extraActionButtonClasses,
        title: extraActionText,
        visibleIndex: 51,
        visible: extraActionVisible,
        action: () => extraAction(),
      })
    }

    if (autoValidate) {
      survey.validate()
    }

    survey.onValidateQuestion.add((survey, options) => {
      const { name, value } = options

      if (name === 'weight') {
        const numValue = parseFloat(value)
        if (isNaN(numValue) || numValue <= 0) {
          options.error = t('validations:validation.weightMustBePositive') || 'El peso debe ser un número positivo mayor que 0'
        } else if (numValue > 400) {
          options.error = t('validations:validation.weightTooHigh') || 'El valor ingresado supera el límite máximo'
        }
      }

      if (name === 'height') {
        const numValue = parseFloat(value)
        if (isNaN(numValue) || numValue <= 0) {
          options.error = t('validations:validation.heightMustBePositive') || 'La altura debe ser un número positivo mayor que 0'
        } else if (numValue > 300) {
          options.error = t('validations:validation.heightTooHigh') || 'El valor ingresado supera el límite'
        }
      }
    })

    const handleWheelOnNumberInputs = (e) => {
      if (e.target.type === 'number') {
        e.preventDefault()
      }
    }

    survey.onAfterRenderSurvey.add(() => {
      const numberInputs = document.querySelectorAll('input[type="number"]')
      numberInputs.forEach(input => {
        input.addEventListener('wheel', handleWheelOnNumberInputs, { passive: false })
      })
    })

    return () => {
      const numberInputs = document.querySelectorAll('input[type="number"]')
      numberInputs.forEach(input => {
        input.removeEventListener('wheel', handleWheelOnNumberInputs)
      })
    }
  }, [survey])

  return <Survey model={survey} />
}